import React, { useState } from "react";
import { Result, Button, message } from "antd";
import { LockOutlined } from "@ant-design/icons";
import { useAgentBillingStatus } from "../../../contexts/AgentBillingStatusContext";
import { startAgentBillingSetup } from "../../../services/agentBillingStatusApi";

/**
 * ה-"תוכן" של הדשבורד כש-isBlocked = true.
 *
 * מוצג במקום `children` בתוך AgentDashboardChrome עבור סוכן חסום.
 * זהו ה-route guard האפקטיבי:
 *   * כל navigation ל-/p/dashboard/* יוביל לכאן כל עוד isBlocked,
 *     כי ה-chrome הוא הראוטר-ראשי לנתיבי הסוכן.
 *   * גם URL ידני לא עוקף — הגישה לכל עמוד דאשבורד מוחלפת בתצוגה נעולה.
 *   * ה-BillingMigrationGateModal נשאר פתוח מעל זה (לא ניתן לסגור).
 *
 * ה-CTA כאן מחובר ישירות ל-POST /api/agent/billing/setup ומבצע redirect ל-HYP.
 */
export default function BillingLockedView() {
  const { reload } = useAgentBillingStatus();
  const [loading, setLoading] = useState(false);

  const handleOpenBillingSetup = async () => {
    if (loading) return;
    setLoading(true);
    try {
      const payload = await startAgentBillingSetup();
      const setupUrl = payload?.setupUrl || payload?.redirectUrl;
      if (!setupUrl) {
        message.error("שגיאה בפתיחת הסדרת התשלום. נסה שוב.");
        setLoading(false);
        return;
      }
      window.location.href = setupUrl;
    } catch (err) {
      const serverCode = err?.response?.data?.code;
      if (serverCode === "not_legacy_unbilled") {
        message.info("מצב המנוי עודכן. המסך ירוענן אוטומטית.");
        try {
          await reload();
        } catch {
          /* ignore */
        }
      } else {
        message.error("שגיאה בפתיחת הסדרת התשלום. נסה שוב.");
      }
      setLoading(false);
    }
  };

  return (
    <div
      className="billing-locked-view"
      style={{
        display: "flex",
        flex: 1,
        width: "100%",
        minHeight: "60vh",
        alignItems: "center",
        justifyContent: "center",
        padding: "24px",
      }}
    >
      <Result
        icon={<LockOutlined style={{ color: "#d4380d" }} />}
        status="warning"
        title="הגישה הוגבלה עד להסדרת אמצעי תשלום"
        subTitle="כדי להמשיך להשתמש במערכת, יש להסדיר כעת אמצעי תשלום."
        extra={
          <Button
            type="primary"
            size="large"
            onClick={handleOpenBillingSetup}
            loading={loading}
            disabled={loading}
          >
            הסדרת אמצעי תשלום
          </Button>
        }
      />
    </div>
  );
}
